var React = require('react');

function ArrowUpInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow-up"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"FInal","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Manual-22","transform":"translate(-807.000000, -673.000000)","fill":"#000000","fillRule":"nonzero"},React.createElement("g",{"id":"Group-2","transform":"translate(570.000000, 649.000000)"},React.createElement("path",{"d":"M249,32.0001 L248.9991,24.9996 C249,24.4479 248.5518,24 248.0001,24 L240.9999,24 L240.9999,25.9995 L245.5848,25.9995 L237,34.5855 L238.4142,36 L246.9999,27.4155 L246.9999,31.9998 L249,31.9998 L249,32.0001 Z","id":"Arrow-up"}))))]);
}

ArrowUpInline.defaultProps = {"width":"12px","height":"12px","viewBox":"0 0 12 12","version":"1.1"};

module.exports = ArrowUpInline;

ArrowUpInline.default = ArrowUpInline;
